const getShortFormDate = (): string => {
  const now = new Date();
  return now.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric'
  });
};

export const generateShareText = (score: number): string => {
  return `🏆 ${score} points`;
};

export const generateShareTitle = (): string => {
  return `⭐ Famous Initials ${getShortFormDate()}`;
}

export const generateShareUrls = (score: number) => {
  const gameText = encodeURIComponent(generateShareText(score));
  const gameUrl = encodeURIComponent('https://famousinitials.com');

  return {
    twitter: `https://twitter.com/intent/tweet?text=${gameText}&url=${gameUrl}&hashtags=FamousInitials,GuessTheGame`,
  };
};

export const handleNativeShare = async (score: number): Promise<void> => {
  const shareText = generateShareText(score);
  const shareTitle = generateShareTitle();
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  if (navigator.share) {
    try {
      const shareData = isMobile
        // Mobile: omit title property
        ? { text: `${shareTitle}\n${shareText}` }
        // Desktop: include title property
        : { title: shareTitle, text: shareText };

      await navigator.share(shareData);
    } catch (error) {
      // Ignore errors and fallback to other methods
    }
  }
};

export const handleFacebookShare = (score: number): void => {
  const gameUrl = 'https://famousinitials.com';
  const gameText = generateShareText(score);
  const gameTitle = generateShareTitle();

  // Try Web Share API first (works better on mobile)
  if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
    navigator.share({
      text: `${gameTitle}\n${gameText}`,
    }).catch(() => {
      // Fallback to Facebook URL
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(gameUrl)}`, '_blank');
    });
  } else {
    // Desktop Facebook share
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(gameUrl)}`, '_blank');
  }
};